export const Prices =[
    {
        _id:0,
        name:"Rs. 0 to 100",
        array:[0,100]
    },
    {
        _id:1,
        name:"Rs. 101to 499",
        array:[101,499]
    },
    {
        _id:2,
        name:"Rs. 500 to 999",
        array:[500,999]
    },
    {
        _id:3,
        name:"Rs. 1000 to 1999",
        array:[1000,1999]
    },
    {
        _id:4,
        name:"Rs. 2000 to 4999",
        array:[2000,4999]
    },
    {
        _id:5,
        name:"Rs. 5000 or more",
        array:[5000,99999]
    },
   
]